// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file knop/ui/v1/api/retshifts.proto (package knop.ui.v1.api, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { ResponseStatus } from "./util/response_status_pb.js";

/**
 * @generated from message knop.ui.v1.api.RetShiftRequest
 */
export class RetShiftRequest extends Message<RetShiftRequest> {
  /**
   * @generated from field: string instance_id = 1;
   */
  instanceId = "";

  constructor(data?: PartialMessage<RetShiftRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.RetShiftRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RetShiftRequest {
    return new RetShiftRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RetShiftRequest {
    return new RetShiftRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RetShiftRequest {
    return new RetShiftRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RetShiftRequest | PlainMessage<RetShiftRequest> | undefined, b: RetShiftRequest | PlainMessage<RetShiftRequest> | undefined): boolean {
    return proto3.util.equals(RetShiftRequest, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.RetShiftResponse
 */
export class RetShiftResponse extends Message<RetShiftResponse> {
  /**
   * @generated from field: repeated knop.ui.v1.api.RetShift ret_shifts = 1;
   */
  retShifts: RetShift[] = [];

  /**
   * @generated from field: knop.ui.v1.api.util.ResponseStatus status = 2;
   */
  status = ResponseStatus.UNKNOWN;

  /**
   * @generated from field: string message = 3;
   */
  message = "";

  constructor(data?: PartialMessage<RetShiftResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.RetShiftResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ret_shifts", kind: "message", T: RetShift, repeated: true },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(ResponseStatus) },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RetShiftResponse {
    return new RetShiftResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RetShiftResponse {
    return new RetShiftResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RetShiftResponse {
    return new RetShiftResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RetShiftResponse | PlainMessage<RetShiftResponse> | undefined, b: RetShiftResponse | PlainMessage<RetShiftResponse> | undefined): boolean {
    return proto3.util.equals(RetShiftResponse, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.RetShift
 */
export class RetShift extends Message<RetShift> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string service_number = 2;
   */
  serviceNumber = "";

  /**
   * @generated from field: google.protobuf.Timestamp start = 3;
   */
  start?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end = 4;
   */
  end?: Timestamp;

  /**
   * @generated from field: repeated knop.ui.v1.api.Actions actions = 5;
   */
  actions: Actions[] = [];

  constructor(data?: PartialMessage<RetShift>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.RetShift";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "service_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "start", kind: "message", T: Timestamp },
    { no: 4, name: "end", kind: "message", T: Timestamp },
    { no: 5, name: "actions", kind: "message", T: Actions, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RetShift {
    return new RetShift().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RetShift {
    return new RetShift().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RetShift {
    return new RetShift().fromJsonString(jsonString, options);
  }

  static equals(a: RetShift | PlainMessage<RetShift> | undefined, b: RetShift | PlainMessage<RetShift> | undefined): boolean {
    return proto3.util.equals(RetShift, a, b);
  }
}

/**
 * @generated from message knop.ui.v1.api.Actions
 */
export class Actions extends Message<Actions> {
  /**
   * @generated from field: knop.ui.v1.api.Actions.Type type = 1;
   */
  type = Actions_Type.UNKNOWN;

  /**
   * @generated from field: string description = 2;
   */
  description = "";

  /**
   * @generated from field: google.protobuf.Timestamp start = 3;
   */
  start?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end = 4;
   */
  end?: Timestamp;

  /**
   * @generated from field: string track = 5;
   */
  track = "";

  /**
   * @generated from field: string train_number = 6;
   */
  trainNumber = "";

  /**
   * @generated from field: string from_track = 7;
   */
  fromTrack = "";

  /**
   * @generated from field: string train_number_departure = 8;
   */
  trainNumberDeparture = "";

  constructor(data?: PartialMessage<Actions>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.api.Actions";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(Actions_Type) },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "start", kind: "message", T: Timestamp },
    { no: 4, name: "end", kind: "message", T: Timestamp },
    { no: 5, name: "track", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "train_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "from_track", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "train_number_departure", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Actions {
    return new Actions().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Actions {
    return new Actions().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Actions {
    return new Actions().fromJsonString(jsonString, options);
  }

  static equals(a: Actions | PlainMessage<Actions> | undefined, b: Actions | PlainMessage<Actions> | undefined): boolean {
    return proto3.util.equals(Actions, a, b);
  }
}

/**
 * @generated from enum knop.ui.v1.api.Actions.Type
 */
export enum Actions_Type {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: MOVE = 1;
   */
  MOVE = 1,

  /**
   * @generated from enum value: VGM = 2;
   */
  VGM = 2,

  /**
   * @generated from enum value: GVGM = 3;
   */
  GVGM = 3,

  /**
   * @generated from enum value: VGMS = 4;
   */
  VGMS = 4,

  /**
   * @generated from enum value: WALKING = 5;
   */
  WALKING = 5,

  /**
   * @generated from enum value: SCHAFT = 6;
   */
  SCHAFT = 6,

  /**
   * @generated from enum value: COMBINE = 7;
   */
  COMBINE = 7,

  /**
   * @generated from enum value: SPLIT = 8;
   */
  SPLIT = 8,

  /**
   * @generated from enum value: VOORTIJD = 9;
   */
  VOORTIJD = 9,

  /**
   * @generated from enum value: NATIJD = 10;
   */
  NATIJD = 10,
}
// Retrieve enum metadata with: proto3.getEnumType(Actions_Type)
proto3.util.setEnumType(Actions_Type, "knop.ui.v1.api.Actions.Type", [
  { no: 0, name: "UNKNOWN" },
  { no: 1, name: "MOVE" },
  { no: 2, name: "VGM" },
  { no: 3, name: "GVGM" },
  { no: 4, name: "VGMS" },
  { no: 5, name: "WALKING" },
  { no: 6, name: "SCHAFT" },
  { no: 7, name: "COMBINE" },
  { no: 8, name: "SPLIT" },
  { no: 9, name: "VOORTIJD" },
  { no: 10, name: "NATIJD" },
]);

